// extracted by mini-css-extract-plugin
export default {"component":"qhA5U","image":"Tzzdu"};